export enum Type {
  LOG_OPERATION_ADD  = 'LOG_OPERATION_ADD',
  LOG_OPERATION_INIT = 'LOG_OPERATION_INIT'
}